import nanoid from 'nanoid';

const SESSION_KEY_PREFIX = 'anna_auth_session_';
const SESSION_EXPIRATION_MINUTES = 10;
const SESSION_CLEANUP_MINUTES = 60;

const minutesSince = (createdAt) => (Date.now() - new Date(createdAt).getTime()) / 60000;

const sessionKey = (sessionId) => `${SESSION_KEY_PREFIX}${sessionId}`;

// Must match byte for byte between the /authorize request and the /token exchange.
export const getCallbackUrl = () => `${window.location.origin}/auth/finish`;

// In-app path only, so a tampered session can't make the post-login hop an open redirect.
const isSafeEntryPath = (entryPath) => typeof entryPath === 'string'
  && entryPath.startsWith('/')
  && !entryPath.startsWith('//');

export const readSession = (sessionId) => {
  if (!sessionId) {
    return null;
  }
  try {
    const raw = localStorage.getItem(sessionKey(sessionId));
    if (!raw) {
      return null;
    }
    const session = JSON.parse(raw);
    return session && isSafeEntryPath(session.entryPath) ? session : null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const removeSession = (sessionId) => {
  try {
    localStorage.removeItem(sessionKey(sessionId));
  } catch (err) {
    console.error(err);
  }
};

export const isSessionExpired = (session) => (
  minutesSince(session.createdAt) > SESSION_EXPIRATION_MINUTES
);

// Own key per login, so two tabs signing in from different urls each come back to their own.
export const startSession = (entryPath) => {
  const sessionId = nanoid();
  try {
    localStorage.setItem(sessionKey(sessionId), JSON.stringify({
      entryPath,
      createdAt: new Date().toISOString(),
    }));
  } catch (err) {
    console.error(err);
  }
  return sessionId;
};

export const cleanSessions = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(SESSION_KEY_PREFIX))
      .forEach((key) => {
        let session;
        try {
          session = JSON.parse(localStorage.getItem(key));
        } catch (err) {
          session = null;
        }
        const stale = !session || !session.createdAt
          || minutesSince(session.createdAt) >= SESSION_CLEANUP_MINUTES;
        if (stale) {
          localStorage.removeItem(key);
        }
      });
  } catch (err) {
    console.error(err);
  }
};
